import { NextPage } from "next";
import { useIntl } from "react-intl";
import { PageProps } from "@/pages/_app";
import Layout from "@/components/layout/Layout";
import { SEO } from "@/interfaces/seo";
import { SEOWithoutTemplate } from "@/interfaces/seoWithoutTemplate";
import HeroBlock, {
  HeroBlockProps,
} from "@/components/common/heroBlock/HeroBlock";
import {
  DescriptiveBlockList,
  DescriptiveBlockListProps,
} from "@/components/common/descriptiveBlockList/DescriptiveBlockList";
import { Section } from "@/components/common/section/Section";
import {
  PointOfInterestList,
  PointOfInterestListProps,
} from "@/components/common/pointOfInterestList/PointOfInterestList";
export type PartnerPageContent = {
  heroBlock: HeroBlockProps;
  pointOfInterestList: PointOfInterestListProps | undefined;
  descriptiveBlockList: DescriptiveBlockListProps | undefined;
  breadcrumbLabel: string;
  seo: SEO;
  seoWithoutTemplate: SEOWithoutTemplate;
};
type PartnerPageProps = PageProps &
  PartnerPageContent & {
    defaultCanonicalRoute: string;
  };

export const PartnerPage: NextPage<PartnerPageProps> = ({
  layout,
  heroBlock,
  pointOfInterestList,
  descriptiveBlockList,
  breadcrumbLabel,
  seo,
  seoWithoutTemplate,
  defaultCanonicalRoute,
}: PartnerPageProps) => {
  const intl = useIntl();

  return (
    <>
      <Layout
        layout={layout}
        defaultCanonicalRoute={defaultCanonicalRoute}
        pageMeta={seo}
        title={seoWithoutTemplate.title}
        description={seoWithoutTemplate.description}
        breadcrumbs={[
          { title: intl.formatMessage({ id: "home" }), url: "/" },
          {
            title: breadcrumbLabel,
            url: defaultCanonicalRoute,
          },
        ]}
      >
        <HeroBlock {...heroBlock} hideSearchBlock={true} />
        <Section>
          {pointOfInterestList && (
            <PointOfInterestList
              location={""}
              pointOfInterestList={pointOfInterestList}
            />
          )}

          {descriptiveBlockList && (
            <DescriptiveBlockList {...descriptiveBlockList} />
          )}
        </Section>
      </Layout>
    </>
  );
};
